module.exports = __webpack_public_path__ + "img/42563f3f392eefb12bbeee2574f846ad.d57131ea.png";